import { Table, Text } from '@factorialco/deprecated-design-system'
import {
  PayrollConceptFragment,
  ReimbursablePayrollConceptFragment,
  TimeSettingsCustomTimeRangeCategoryFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import TimeReimbursementRow from 'modules/compensations/components/MapTimeCategoryWithPayrollConcept/_Row'
import { useCategorizedPayrollConcepts } from 'modules/compensations/components/PayrollConceptSelectField/CategorizedPayrollConceptUtil'

interface Props {
  reimbursements: ReimbursablePayrollConceptFragment[]
  payrollConcepts: PayrollConceptFragment[]
  timeRangeCategories: TimeSettingsCustomTimeRangeCategoryFragment[]
  onRowChanged: (timeCategoryId: string, payrollConceptId: string) => void
}

const MapTimeCategoryWithPayrollConcept = ({
  reimbursements,
  payrollConcepts,
  timeRangeCategories,
  onRowChanged,
}: Props) => {
  const payrollConceptsOptions = useCategorizedPayrollConcepts(payrollConcepts ?? [])

  const rows = timeRangeCategories
    .map((timeCategory) => {
      const reimbursement = reimbursements?.find((p) => p.reimbursableId === timeCategory.id)

      const payrollConcept = payrollConcepts?.find(
        (pc) => String(pc.id) === String(reimbursement?.payrollConceptId)
      )
      return {
        reimbursement,
        timeCategory,
        payrollConcept,
      }
    })
    .filter((row) => row.timeCategory)

  return (
    <Table fullWidth>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell width={300} sticky={{ position: 'left', delimiter: true }}>
            <Text.Normal weight="bold">
              {i18n.t(
                'compensations.settings.time_reimbursements.time_reimbursements_table.time_tracking_category'
              )}
            </Text.Normal>
          </Table.HeadCell>
          <Table.HeadCell width={300}>
            <Text.Normal weight="bold">
              {i18n.t(
                'compensations.settings.time_reimbursements.time_reimbursements_table.payroll_concept'
              )}
            </Text.Normal>
          </Table.HeadCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {rows?.map(({ reimbursement, timeCategory, payrollConcept }) => (
          <TimeReimbursementRow
            key={`row_${timeCategory.id}_${payrollConcept?.id}_${reimbursement?.id}`}
            timeCategory={timeCategory}
            payrollConcept={payrollConcept}
            payrollConcepts={payrollConceptsOptions}
            onRowChanged={onRowChanged}
          />
        ))}
      </Table.Body>
    </Table>
  )
}

export default MapTimeCategoryWithPayrollConcept
